"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextNode = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const rpdf_renderer_1 = require("@surge-global-engineering/rpdf-renderer");
const styles = rpdf_renderer_1.StyleSheet.create({
    superscript: {
        fontVariant: 'superscript',
    },
    subscript: {
        fontVariant: 'subscript',
    },
    bold: {
        fontWeight: 900,
    },
    italic: {
        fontStyle: 'italic',
    },
    underline: {
        textDecoration: 'underline',
    },
    strikeThrough: {
        textDecoration: 'line-through',
    },
    smallCaps: {
        fontVariant: 'small-caps',
    },
    baseStyles: {},
    // special styles
    underlineStrikeThrough: {
        textDecoration: 'underline line-through',
    },
});
const featureToStyleMap = {
    superscript: 'superscript',
    subscript: 'subscript',
    bold: 'bold',
    italic: 'italic',
    underline: 'underline',
    strikeThrough: 'strikeThrough',
    smallCaps: 'smallCaps',
};
const TextNode = (_a) => {
    var { style, orphans = 2, widows = 2 } = _a, otherProps = tslib_1.__rest(_a, ["style", "orphans", "widows"]);
    // used to get the list item type if the current is a list item
    const composedStyles = [];
    const composeStyles = () => {
        composedStyles.push(Object.assign(Object.assign({}, styles.baseStyles), { fontSize: otherProps.fontSize, lineHeight: otherProps.lineHeight }));
        if (style && Array.isArray(style)) {
            composedStyles.push(...style);
        }
        else {
            composedStyles.push(Object.assign({}, style));
        }
        // to add the relevant styles for the passed props
        for (const [propName, styleName] of Object.entries(featureToStyleMap)) {
            if (otherProps[propName]) {
                composedStyles.push(styles[styleName]);
            }
        }
    };
    const handleSpecialStyles = () => {
        //handle spacial style cases
        const { underline, strikeThrough } = otherProps;
        if (underline && strikeThrough) {
            composedStyles.push(styles.underlineStrikeThrough);
        }
    };
    composeStyles();
    handleSpecialStyles();
    return (jsx_runtime_1.jsx(rpdf_renderer_1.Text, Object.assign({ widows: widows, orphans: orphans, style: Object.assign({}, Object.assign({}, ...composedStyles)) }, otherProps, { children: otherProps.children }), void 0));
};
exports.TextNode = TextNode;
//# sourceMappingURL=text-node.js.map